// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject = (value: any): boolean => typeof value === 'object' && value !== null;
